// se
// export const BASE_URL_SE = 'https://dev.se.api.operations.nowpay.cloud/';
export const BASE_URL_SE = 'https://se.api.operations.nowpay.cloud/';

// eg
// export const BASE_URL_EG = 'https://dev.api.operations.nowpay.cloud/';
export const BASE_URL_EG = 'https://api.operations.nowpay.cloud/';
// export const BASE_URL_EG = 'https://beta.api.operations.nowpay.cloud/';
